export enum PreviewMode {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}
